import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMarginRight12 from './IconMarginRight12';
import IconMarginRight16 from './IconMarginRight16';
import IconMarginRight20 from './IconMarginRight20';
import IconMarginRight24 from './IconMarginRight24';
import IconMarginRight32 from './IconMarginRight32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMarginRight = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMarginRight12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMarginRight16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMarginRight20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMarginRight24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMarginRight32 {...props} />}
        </span>
    );
};
IconMarginRight.displayName = 'FondueIconMarginRight';

export default memo(IconMarginRight);
